interface PageHeroProps {
  title: string;
  subtitle: string;
  badgeLabel: string;
  badgeColor?: string;
  backgroundImage: string;
  showFeatureBadges?: boolean;
}

export default function PageHero({
  title,
  subtitle,
  badgeLabel,
  badgeColor = 'bg-amber-500/20 border-amber-500/40 text-amber-400',
  backgroundImage,
  showFeatureBadges = true,
}: PageHeroProps) {
  return (
    <section className="relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url('${backgroundImage}')` }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/75 to-black/90"></div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-7 text-center">
        <div className="flex items-center justify-center gap-4 mb-3">
          <h1 className="text-2xl md:text-4xl font-extrabold bg-gradient-to-r from-amber-400 via-teal-400 to-emerald-400 bg-clip-text text-transparent leading-tight">
            {title}
          </h1>
        </div>
        <p className="text-slate-300 text-sm md:text-base max-w-2xl mx-auto mb-4">
          {subtitle}
        </p>
        {showFeatureBadges && (
          <div className="grid grid-cols-2 sm:flex sm:flex-wrap items-center justify-center gap-3 sm:gap-4 text-xs max-w-sm sm:max-w-none mx-auto">
            {[
              { icon: 'ri-shield-check-line', label: 'CFTC Regulated' },
              { icon: 'ri-exchange-line', label: 'Buy & Sell Anytime' },
              { icon: 'ri-percent-line', label: 'Zero Juice' },
              { icon: 'ri-global-line', label: 'All 50 States' },
            ].map((f, i) => (
              <div key={i} className="flex items-center justify-center gap-2 text-slate-300">
                <i className={`${f.icon} text-lg`}></i>
                <span>{f.label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
